import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Language } from '../modules/core/enums/lanugage.enum';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly defaultLanguage = Language.English;

  constructor(private translate: TranslateService) {
    this.translate.setDefaultLang(this.defaultLanguage);
    const savedLanguage = localStorage.getItem('language') as Language;
    if (savedLanguage && Object.values(Language).includes(savedLanguage)) {
      this.translate.use(savedLanguage);
    } else {
      this.translate.use(this.defaultLanguage);
    }
  }

  setLanguage(language: Language) {
    this.translate.use(language);
    localStorage.setItem('language', language);
  }

  getLanguage(): Language {
    const savedLanguage = localStorage.getItem('language') as Language;
    return Object.values(Language).includes(savedLanguage)
      ? savedLanguage
      : this.defaultLanguage;
  }
}
